import { Component, Input, Output, EventEmitter, HostListener, forwardRef, ViewChild, ViewEncapsulation, SimpleChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { VesselsService } from 'src/app/services/vessels.service';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SearchInputComponent),
  multi: true
};

@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR],
  encapsulation: ViewEncapsulation.None,
})
export class SearchInputComponent  {
  @ViewChild('auto') auto:any;

  @Input() data: any;
  @Input() label: string;
  @Input() selectedValue:any;
  @Input() searchText:any;
  @Input() addShipErrormsg:string;
  
  @Output() searchValue = new EventEmitter();
  @Output() resetDropdown = new EventEmitter();
  @Output() emitNoShipFound = new EventEmitter();
  
  filterText:any;
  isSelectedValue: boolean;
  key: string;
  isFocused: boolean;
  searchIcon: boolean = true;
  keyword = 'name';
  noShipFound:boolean = false;
  isserachText: boolean = false;

  // ngOnChanges(Changes:SimpleChanges){
  //   if(Changes['data']){
  //      console.log("data",this.data)
  //   }
  // }

  /**
   *Creates an instance of SearchInputComponent.
   * @memberof SearchInputComponent
   */

  // constructor(private _vesselService: VesselsService){
  //   let searchData =  this._vesselService.serachShipData?.map((items:any)=>({id: items.vslCode ,
  //   name: this.convertFirstLetterToUpperCase(items?.vslName) + ' (' + items.vslNumber + ')'  }))
  //   console.log(searchData)
  //   // this.searchValue.emit(searchData[0]?.id);
  //   // this.searchText = searchData[0]?.name;
  // }
  // convertFirstLetterToUpperCase(str: any) {
  //   let splitStr = str.toLowerCase().split(' ');
  //   for (let i = 0; i < splitStr.length; i++) {
  //     splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  //   }
  //   return splitStr.join(' ');
  // }

ngAfterViewInit() {
  setInterval(() => {
    const msg = document.querySelector('.addShipErrormsg');
    const newState = !!msg;
    if (newState !== this.noShipFound) {  
      this.noShipFound = newState;
      this.emitNoShipFound.emit(this.noShipFound);
    }
  }, 200);
}
  @HostListener('focus')
  focusHandler() {
    this.isFocused = true;
  }

  @HostListener('focusout')
  focusOutHandler() {
    this.isFocused = false;
  }

  valuechange(value:any) {
    console.log(value)
    let tempSearchText = value;
    this.filterText = '';
    if(tempSearchText.length > 2){
      this.filterText =  tempSearchText;
    }
    this.searchValue.emit(value);
    
  }

  selectEvent(item:any) {
    // this._vesselService.serachShipData = item;
    this.searchValue.emit(item.id);
     this.searchIcon = false;
   
    // do something with selected item
  }

  onClearSearch() {
    this.searchValue.emit('');
    this.searchIcon = true;
    this.isserachText = false;
     console.log(this.searchIcon)
  }

  onChangeSearch(search: string) {
    this.searchIcon = (search) ? false : true;
    console.log(search)
    if(search){
       this.isserachText = true;
    }else{
       this.isserachText = false;
    }
   

  }

  onFocused(e:any) {
    this.isFocused = true;
    console.log(e)
    // do something
  }

}